
(() => {
  function prepareRelease(root) {
    if (root.dataset.releaseReady || root.dataset.dropPhase !== 'preview') return;
    const release = Date.parse(root.dataset.dropRelease);
    if (!Number.isFinite(release) || !root.dataset.dropSection) return;
    root.dataset.releaseReady = 'true';
    let attempts = 0;
    let refreshing = false;
    const refresh = async () => {
      if (!root.isConnected || refreshing) return;
      if (Date.now() < release) {
        setTimeout(refresh, Math.min(release - Date.now() + 1000, 86400000));
        return;
      }
      refreshing = true;
      attempts += 1;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', root.dataset.dropSection);
        url.searchParams.set('_drop_refresh', String(Date.now()));
        url.searchParams.delete('customer_posted');
        const response = await fetch(url.href, { cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Release section unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = html.querySelector('[data-drop-section]');
        if (!next || next.dataset.dropSection !== root.dataset.dropSection || next.dataset.dropPhase !== 'public') throw new Error('Release section not ready');
        root.replaceWith(next);
        prepare(document);
      } catch (_) {
        const clock = root.querySelector('[data-drop-countdown]');
        if (clock) clock.textContent = 'Release time reached. Refresh to see the latest availability.';
        if (attempts < 10 && root.isConnected) setTimeout(refresh, 30000);
      } finally {
        clearTimeout(timeout);
        refreshing = false;
      }
    };
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && root.isConnected && Date.now() >= release) refresh();
    });
    refresh();
  }
  function prepare(scope) {
    scope.querySelectorAll('[data-drop-section]').forEach(prepareRelease);
    scope.querySelectorAll('[data-drop-background]').forEach(hero => {
      if (hero.dataset.videoReady) return;
      const video = hero.querySelector('video');
      const button = hero.querySelector('[data-drop-video-toggle]');
      if (!video || !button) return;
      hero.dataset.videoReady = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => { button.textContent = video.paused ? 'Play video' : 'Pause video'; };
      let openingTimer;
      let interacted = false;
      const play = () => {
        clearTimeout(openingTimer);
        video.play().catch(() => { hero.classList.add('is-still'); update(); });
      };
      video.muted = true;
      button.hidden = false;
      video.addEventListener('playing', () => { hero.classList.remove('is-still'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { hero.classList.add('is-still'); update(); });
      button.addEventListener('click', () => {
        interacted = true;
        clearTimeout(openingTimer);
        if (video.paused) play(); else video.pause();
      });
      const begin = () => {
        if (reducedMotion.matches || interacted || !hero.isConnected) return;
        const delay = Number(hero.dataset.dropProductOpening) || 0;
        if (delay) openingTimer = setTimeout(() => {
          if (!reducedMotion.matches && !interacted && hero.isConnected) play();
        }, delay);
        else play();
      };
      if (reducedMotion.matches) { video.autoplay = false; video.pause(); }
      else {
        const poster = hero.querySelector('.drop-hero-media > img');
        if (hero.dataset.dropProductOpening && poster && !poster.complete) {
          poster.addEventListener('load', begin, { once: true });
          poster.addEventListener('error', begin, { once: true });
        } else begin();
      }
      reducedMotion.addEventListener('change', event => {
        if (event.matches) { clearTimeout(openingTimer); video.pause(); hero.classList.add('is-still'); }
      });
      update();
    });

    scope.querySelectorAll('[data-drop-section]').forEach(root => {
      const dialog = root.querySelector('.drop-image-dialog');
      if (!dialog || dialog.dataset.imageReady) return;
      dialog.dataset.imageReady = 'true';
      const image = dialog.querySelector('[data-drop-enlarged-image]');
      const caption = dialog.querySelector('[data-drop-enlarged-caption]');
      const close = dialog.querySelector('[data-drop-image-close]');
      let opener;
      root.querySelectorAll('[data-drop-image-open]').forEach(button => {
        button.addEventListener('click', () => {
          opener = button;
          image.src = button.dataset.imageSrc;
          image.alt = button.dataset.imageAlt;
          caption.textContent = button.dataset.imageCaption;
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
            close.focus();
          } else window.open(button.dataset.imageSrc, '_blank', 'noopener');
        });
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus({ preventScroll: true }); });
    });

    scope.querySelectorAll('[data-drop-countdown]').forEach(el => {
      if(el.dataset.ready) return;
      el.dataset.ready='true';
      const end=Date.parse(el.dataset.dropCountdown);
      if(!Number.isFinite(end)) return;
      const tick=()=>{
        const left=Math.max(0,Math.floor((end-Date.now())/1000));
        if(!left){el.textContent='Release time reached. Check back shortly.';return false;}
        el.textContent=`${Math.floor(left/86400)}d ${String(Math.floor(left/3600)%24).padStart(2,'0')}h ${String(Math.floor(left/60)%60).padStart(2,'0')}m`;
        return true;
      };
      if(tick()){const timer=setInterval(()=>{if(!el.isConnected||!tick())clearInterval(timer);},1000);}
    });
    scope.querySelectorAll('[data-drop-local-time]').forEach(el=>{
      const date=new Date(el.dataset.dropLocalTime);
      if(Number.isFinite(date.getTime())) el.textContent='Your time: '+new Intl.DateTimeFormat(undefined,{month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(date);
    });
    scope.querySelectorAll('[data-drop-product]').forEach(el=>{
      if(el.dataset.ready) return; el.dataset.ready='true';
      const select=el.querySelector('select[name="id"]'), price=el.querySelector('[data-drop-price]'), button=el.querySelector('[data-drop-buy]');
      if(!select||!price||!button)return;
      const update=()=>{const option=select.selectedOptions[0]; price.textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to cart';};
      select.addEventListener('change',update);update();
    });
  }
  prepare(document);
  document.addEventListener('shopify:section:load',event=>prepare(event.target));
})();
